export default function performancePrefetchLinksController() {
  if (!window.performanceSettings.prefetchLinks) {
    return;
  }

  const links = document.querySelectorAll('a');

  links.forEach((link) => {
    let href = link.getAttribute('href');

    if (typeof href !== 'string' || !href.trim()) {
      return;
    }
    href = href.trim();

    const lowerHref = href.toLowerCase();

    if (!(href.startsWith('/') || lowerHref.startsWith('https://'))) {
      return;
    }

    try {
      const url = new URL(href, document.location.origin);

      if (url.protocol !== 'https:' && url.protocol !== 'http:') {
        return;
      }
    } catch (error) {
      return;
    }

    link.addEventListener(
      'mouseover',
      () => {
        const prefetchLink = document.createElement('link');
        prefetchLink.rel = 'prefetch';
        prefetchLink.href = href;
        document.head.appendChild(prefetchLink);
      },
      { once: true }
    );
  });
}
